/**
 * Creates dark theme colors object with dynamic mainColor and iconColor values.
 * This function allows colors to be reactive to theme changes.
 * 
 * @param mainColor - The main color (default: '#90caf9')
 * @param iconColor - The icon color (default: '#ffffff')
 * @returns Colors object with dynamic palette values for dark theme
 */
export const createColorsDark = (mainColor: string = '#90caf9', iconColor: string = '#ffffff') => {
  const palette = {
    neutral100: '#000000',
    neutral200: '#191015',
    neutral300: '#3C3836',
    neutral400: '#564E4A',
    neutral500: '#978F8A',
    neutral600: '#B6ACA6',
    neutral700: '#D7CEC9',
    neutral800: '#F4F2F1',
    neutral900: '#FFFFFF',

    overhearblue: '#214176',
    libraryblue: '#2f5ca6',

    primary100: '#A54F31',
    primary200: '#C76542',
    primary300: '#D28468',
    primary400: '#DDA28E',
    primary500: '#E8C1B4',
    primary600: '#F4E0D9',

    secondary100: '#41476E',
    secondary200: '#626894',
    secondary300: '#9196B9',
    secondary400: '#BCC0D6',
    secondary500: '#DCDDE9',

    accent100: '#FFBB50',
    accent200: '#FBC878',
    accent300: '#FDD495',
    accent400: '#FFE1B2',
    accent500: '#FFEED4',

    angry100: '#C03403',
    angry500: '#F2D6CD',

    overlay20: 'rgba(255, 255, 255, 0.2)',
    overlay50: 'rgba(255, 255, 255, 0.5)',

    main: mainColor,
    icon: iconColor,
  } as const

  return {
    palette: {
      ...palette,
      // Additional palette properties for web components
      border: '#424242',
      input: {
        background: '#1e1e1e',
        text: '#ffffff',
      },
      button: {
        primary: mainColor,
        secondary: '#f48fb1',
        text: '#000000',
      },
      dropdown: {
        background: '#1e1e1e',
        hover: '#424242',
        selected: '#1976d2',
      },
    },
    transparent: 'rgba(0, 0, 0, 0)',
    text: '#ffffff',
    textDim: '#b0b0b0',
    background: '#121212',
    border: '#424242',
    tint: '#90caf9',
    separator: '#424242',
    error: '#f44336',
    errorBackground: '#f4433620',
    /**
     * Primary color (from mainColor parameter)
     */
    primary: mainColor,
    /**
     * Secondary color
     */
    secondary: '#f48fb1',
  } as const
}

// Default export for backward compatibility
export const colors = createColorsDark()
